import { render, staticRenderFns } from "./YKCAccountView.vue?vue&type=template&id=5d66921f&"
import script from "./YKCAccountView.vue?vue&type=script&lang=js&"
export * from "./YKCAccountView.vue?vue&type=script&lang=js&"
import style0 from "./YKCAccountView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports